import React from "react";
import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import {
  cleanTablePdf,
  cleanTablePdfRI,
  cleanConfigProduct,
} from "../Store/secureInvestmentIncome/actions";
import { cleanAdviser } from "../Store/adviser/actions";
import { logout } from "../Store/loginRedux/actions";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { storage } from "../Utils/storage";
import SimpleModal from "./simpleModal";
import CloudMessage from "./cloudMessage";
import fiInactivityLight from "../Resources/svg/fiInactivityLight.svg";

const ModalExpiredSession = ({ open }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const signOut = () => {
    window.open(process.env.REACT_APP_OAUTH2_LOGOUT);
    Auth.signOut({ global: true })
      .then((res) => console.log(res))
      .catch((e) => console.log(e));
  };

  const granted = useSelector((state) => state.login.granted);

  const closeSession = async () => {
    await dispatch(logout());
    await dispatch(cleanTablePdf());
    await dispatch(cleanTablePdfRI());
    await dispatch(cleanConfigProduct());
    await dispatch(cleanAdviser());
    storage().removeItem("jwt");
    history.push("/login");

    setTimeout(() => {
      signOut();
    }, 500);
  };

  return (
    granted && (
      <SimpleModal isOpen={open}>
        <CloudMessage
          mainMessage="Su sesión ha caducado"
          secondaryMessage="Vuelve a iniciar sesión"
          onClick={() => closeSession()}
          buttonText="Aceptar"
        />
      </SimpleModal>
    )
  );
};

export default ModalExpiredSession;
